import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1.1, delay, ease: EASE }}>
    {children}
  </motion.div>
);

export const ClipImage = ({ src, alt, className = "", testid }) => (
  <motion.div className={className} initial="hide" whileInView="show" viewport={{ once: true, amount: 0.1 }} data-testid={testid}>
    <motion.div className="w-full h-full overflow-hidden"
      variants={{ hide: { clipPath: "inset(0 0 100% 0)" }, show: { clipPath: "inset(0 0 0% 0)" } }}
      transition={{ duration: 1.4, ease: EASE }}>
      <motion.img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover"
        variants={{ hide: { scale: 1.2 }, show: { scale: 1 } }} transition={{ duration: 1.8, ease: EASE }} />
    </motion.div>
  </motion.div>
);

export const SectionHead = ({ label, title, children, light }) => (
  <Reveal className="max-w-3xl">
    <p className={`label mb-6 ${light ? "!text-[#7d5a12]" : ""}`}>{label}</p>
    <h2 className={`font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight ${light ? "text-[#1c1915]" : "text-[#f4f1ea]"}`}>
      {title}
    </h2>
    {children}
  </Reveal>
);
